"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.definition = void 0;
var endpoint_definition_details_generator_1 = require("../../../helpers/endpoint.definition.details.generator");
var api_response_def_1 = require("../../../shared/api.response.def");
var collection_json_def_1 = require("../../../shared/collection.json.def");
exports.definition = (0, endpoint_definition_details_generator_1.makeDefinitionFor)('/collection/{collection_id}.json', {
    description: 'Get the data of a collection',
    method: 'get',
    summary: 'Collection information',
    tags: ['Collection'],
    params: [
        {
            $ref: '#/components/parameters/ikeDepartmentId',
        },
        {
            $ref: '#/components/parameters/collectionIdPath',
        },
    ],
}, [
    {
        code: 200,
        description: api_response_def_1.success,
        schema: collection_json_def_1.collection,
    },
    (0, api_response_def_1.generateValidationError)(),
]);
//# sourceMappingURL=collection.get.schema.js.map